import { render, staticRenderFns } from "./StudentInformationTeaching.vue?vue&type=template&id=1ca8e016&scoped=true&lang=pug&"
import script from "./StudentInformationTeaching.vue?vue&type=script&lang=ts&"
export * from "./StudentInformationTeaching.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInformationTeaching.vue?vue&type=style&index=0&id=1ca8e016&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca8e016",
  null
  
)

export default component.exports